//import React, {Component} from 'react';
import React from 'react';
import PropTypes from 'prop-types';
//import { withStyles } from '@material-ui/core/styles';
import {withStyles} from "@material-ui/core";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
//import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
//import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import HomeIcon from '@material-ui/icons/Home';
//import Icon from '@material-ui/core/Icon';
//import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
//import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@material-ui/core/Tooltip';
import Popover from '@material-ui/core/Popover';
import NavigationIcon from '@material-ui/icons/Navigation';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Grid from "@material-ui/core/Grid";
import GridList from '@material-ui/core/GridList';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Divider from "@material-ui/core/Divider";


/* const styles = {


};*/

const styles = theme => ({
  margin: {
    margin: theme.spacing.unit * 2,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit * 8,
  },
  card: {
    maxWidth: 600,
    //backgroundColor:'#f5e3d0',
    backgroundColor:'#edebdf',
    borderWidth:2,
    borderColor:'black',
    marginBottom:'10px'
  },
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  authpeople: {
    width: '100%',
    maxWidth: 360,
    backgroundColor:"#fab850" ,
  },
  dividerColor1: {
    //marginTop: theme.spacing.unit * 3,
    color:"#40a339",
    backgroundColor:"#40a339",
  },
  
  
});


//'url(' + require('../../images/IMG_1.JPG')
class ExpandableCompanyPropertyInformation  extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      age: '',
      name: 'Farshid',
      testnumber: '1232322',
      labelWidth: 0,
      open:false,
    };
    //const unsubscribe = store.subscribe( () => {/*console.log(store.getState())*/});
    this.deleteImageClick = this.deleteImageClick.bind(this);
    this.editImageClick = this.editImageClick.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.PaperComponent = this.PaperComponent.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.renderLitsOfAuthorizedPersons = this.renderLitsOfAuthorizedPersons.bind(this);
    //renderLitsOfAuthorizedPersons
    
  }
  
  
  deleteImageClick(argData){
    
    //alert('delete was 1 called');
    // this.props.onDelete(argData.id);
    this.setState({ open: true });
    
    
  }
  
  
  editImageClick(argData){
    //alert('edit was  1 called');
    /*const { data} = this.props;
		data.forEach((item)=>{item.editMode = false});
		if(argData.editMode){
				if(argData.editMode == true) {

						argData.editMode = false;
				}else{
						argData.editMode = true;
				}
		}else{
				argData.editMode = true;
		}
		*/
    
    this.props.onEdit(argData);
  }
  
  handleClickOpen(){
    this.setState({ open: true });
  };
  
  handleClose(){
    this.setState({ open: false });
  };
  
  handleDelete(){
    this.props.onDelete(this.props.info.id);
    this.setState({ open: false });
  };
  
  PaperComponent(props) {
    return (
      <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
        <Paper {...props} />
      </Draggable>
    );
  }
  
  
  renderLitsOfAuthorizedPersons(argPeopleArrayString) {
    const {classes} = this.props;
    let peopleArray = [];
    if (argPeopleArrayString != null) {
      // let jasonString = argPeopleArray
      peopleArray = JSON.parse(argPeopleArrayString);
    }
    return (
      < List
        className = {classes.authpeople} >
        {
          peopleArray.map(value => {
            const labelId = `checkbox-list-label-${value}`;
            
            return (
              < ListItem
                key = {value.name}
                role = {undefined}
                dense
                button >
                
                < ListItemText
                  id = {labelId}
                  primary = {`Name: ${value.name}  `}
                  secondary = {`Phone: ${value.phone}`}
                />
              
              < /ListItem>
            )
              ;
          })
        }
      < /List>
    )
      ;
  }
  
  
  
  render() {
    const {classes} = this.props;
    // const classes2 = useStyles();
    let peoplList = this.renderLitsOfAuthorizedPersons(this.props.info.authorizedpeople);
    let tempImageSource = "/static/images/property-icon.png";
    
    return (
      
      < ExpansionPanel  className={classes.card}>
        < ExpansionPanelSummary  style={{ backgroundColor:'#dcdace'}} expandIcon = { < ExpandMoreIcon / > } aria-controls = "panel2a-content" id = "panel2a-header" >
          <Grid container spacing={24}>
            <Grid item xs={2} sm={2}>
              {/*<HomeIcon fontSize="large" color="primary"></HomeIcon>*/}
              <img   style={{ marginTop:5, marginLeft:0,  color:'black', width:40, height:40}} height={40} width={40} src={tempImageSource} />
            
            </Grid>
            <Grid item xs={10} sm={10}>
              <div>
                < Typography  style={{display: 'inline-block'}}
                              variant = "h6" >
                  Property  - {this.props.info.name}
                < /Typography>
              </div>
            </Grid>
          </Grid>
        < /ExpansionPanelSummary>
          < ExpansionPanelDetails>
          <Grid container spacing={24}>
          
          
          {/*
                                <Grid item xs={2} sm={2}>
                                    < Typography  style={{display: 'inline-block'}}
                                variant = "h6"
                                component = "h6" >
                                    Number: {` `}
                                    < /Typography>
                                </Grid>


                                <Grid item xs={3} sm={3}>
                                < Typography  style={{display: 'inline-block'}}
                                variant = "h6"
                                component = "h6" >
                                    {this.props.info.number}
                                    < /Typography>
                                </Grid>
                                */}
          <Grid item xs={6} sm={6}>
            < Typography   style={{display: 'inline-block' , fontWeight:'bold'}}
                           variant="button"
            >
              
              Property Name:
            < /Typography>
            <br/>
            < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                          variant = "body1"
            >
              {this.props.info.name}
            < /Typography>
          </Grid>
          
          
          <Grid item xs={6} sm={6}>
            {/*    < Typography  style={{display: 'inline-block'}}
                                variant = "button"
                                 >
                                    Tax ID:
                            < /Typography>
                                    <br/>
                                < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                                variant = "body1"
                                 >
                                    {this.props.info.ein}
                                < /Typography>
                                */}
          </Grid>
          
          
          <Grid item xs={6} sm={6}>
            < Typography  style={{display: 'inline-block' , fontWeight:'bold'}}
                          variant = "button" >
              Address:
            < /Typography>
            <br/>
            < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                          variant = "body1" >
              {this.props.info.address1}  {this.props.info.address2}
            < /Typography>
          </Grid>
          
          
          <Grid item xs={6} sm={6}>
            < Typography  style={{display: 'inline-block' , fontWeight:'bold'}}
                          variant = "button" >
              City:
            < /Typography>
            <br/>
            < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                          variant = "body1" >
              {this.props.info.city}
            < /Typography>
          </Grid>
          <Grid item xs={6} sm={6}>
            < Typography  style={{display: 'inline-block' , fontWeight:'bold'}}
                          variant = "button" >
              State:
            < /Typography>
            <br/>
            < Typography  style={{display: 'inline-block', marginLeft: 15}}
                          variant = "body1" >
              {this.props.info.state}
            < /Typography>
          </Grid>
          <Grid item xs={6} sm={6}>
            < Typography  style={{display: 'inline-block' , fontWeight:'bold'}}
                          variant = "button" >
              Country:
            < /Typography>
            <br/>
            < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                          variant = "body1" >
              {this.props.info.country}
            < /Typography>
          </Grid>
          
          <Grid item xs={6} sm={6}>
            < Typography  style={{display: 'inline-block' , fontWeight:'bold'}}
                          variant = "button" >
              zipcode:
            < /Typography>
            <br/>
            < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                          variant = "body1" >
              {this.props.info.zipcode}
            < /Typography>
          </Grid>
          <Grid item xs={6} sm={6}>
            < Typography  style={{display: 'inline-block' , fontWeight:'bold'}}
                          variant = "button" >
              Phone:
            < /Typography>
            <br/>
            < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                          variant = "body1" >
              {this.props.info.phone}
            < /Typography>
          </Grid>
          <Grid item xs={6} sm={6}>
            < Typography  style={{display: 'inline-block' , fontWeight:'bold'}}
                          variant = "button" >
              Fax:
            < /Typography>
            <br/>
            < Typography  style={{display: 'inline-block', marginLeft: 15 }}
                          variant = "body1" >
              {this.props.info.fax}
            < /Typography>
          </Grid>
          <Grid item xs={6} sm={6}>
            < Typography  style={{display: 'inline-block', fontWeight:'bold'}}
                          variant = "button" >
              Email:
            < /Typography>
            <br/>
            < Typography  style={{display: 'inline-block', marginLeft: 15 }}
                          variant = "body1" >
              {this.props.info.email}
            < /Typography>
          </Grid>
          {/*  I was trying to show teh number of vehciles here, but becuae itis set from teh edmit menu
                                  all the properties got the same number which is wrong.
                                      <Grid item xs={6} sm={6}>
                                    < Typography  style={{display: 'inline-block', marginLeft: 5 }}
                                        variant = "body1"  > Vehicles Count:  {this.props.VehicleCounts}
                                    < /Typography>
                                  </Grid>
                                  */}
          <Grid item xs={12} sm={12}>
            {/*
                            < Typography  style={{display: 'inline-block'}}
                                variant = "button" >
                                Web Address:
                            < /Typography>
                            <br/>
                            < Typography  style={{display: 'inline-block', marginLeft: 15 }}
                            variant = "body1" >
                                {this.props.info.webpagelink}
                                < /Typography>
                                */}
            < Typography  style={{display: 'inline-block' , fontWeight:'bold'}}
                          variant = "button" >
              Authorized People:
            < /Typography>
            <br/>
            {peoplList}
          
          </Grid>
          
          
          
          <Grid item xs={2} sm={2}>
            <Tooltip title="Delete" aria-label="Delete">
              <IconButton color="secondary" aria-label="delete" className={classes.extendedIcon}>
                <DeleteIcon fontSize="large" onClick={() =>this.deleteImageClick(this.props.info)}/>
              </IconButton>
            
            </Tooltip>
          </Grid>
          
          <Grid item xs={2} sm={2}>
            <Tooltip title="Edit" aria-label="Edit">
              <IconButton  color="primary" aria-label="edit" className={classes.extendedIcon}>
                <EditIcon fontSize="large" onClick={() =>this.editImageClick(this.props.info)}/>
              </IconButton>
            </Tooltip>
          </Grid>
          
          <Grid item xs={8} sm={8}>
          </Grid>
        </Grid>
      
      < /ExpansionPanelDetails>
    <Dialog
      open={this.state.open}
      onClose={this.handleClose}
      PaperComponent={this.PaperComponent}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Do you want to remove the property  {this.props.info.name} ?</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          The Property ( {this.props.info.name} ) at address ( {this.props.info.address1}  ) will be removed from your profile.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={this.handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={this.handleDelete} color="primary" autoFocus>
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  < /ExpansionPanel>
  
  )
    ;
  }//end of render
}//End of class

ExpandableCompanyPropertyInformation.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ExpandableCompanyPropertyInformation);
